import { Component, Inject, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { getPostsecondaryLoadingStatus } from 'Src/ng2/store';

@Component({
  selector: 'base-modal',
  template: require('./base-modal.component.html'),
  styles: [require('./modals.component.scss')],
})
export class BaseModalComponent implements OnInit, OnDestroy, OnChanges {
  @Input() title: any;
  @Input() itemCount: number;
  @Input() itemType: string; // TValid patchable collections
  @Input() isProfileMode?: boolean;
  @Input() buttonMode: string = 'close';
  @Input() backButtonPayload?: any;
  @Input() titleTooltipInfo?: string;

  destroy$: Subject<boolean> = new Subject<boolean>();
  public isDisabled = true;

  // dependencies marked with ? indicate that the derived class optionally will pass that through constructor
  constructor(private dialogRef: MatDialogRef<any>, @Inject('ErrorModal') protected ErrorModal?) {
    //
  }

  ngOnInit(): void {
    /*** */
  }

  ngOnChanges(): void {
    /***/
  }

  ngOnDestroy(this): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onError(payload): void {
    const { message, error } = payload;
    this.dialogRef.close({ action: 'ERROR', error });
    this.ErrorModal.show(message, error);
  }

  close(payload?): void {
    this.dialogRef.close(payload);
  }

  goBack(): void {
    this.dialogRef.close({ goBack: true });
  }
}
